import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import { Box, Typography } from "@mui/material";
import LoadingUI from "../../../components/UI/LoadingUI";
import GoodsIssueTable from "../../../components/Table/Inventory/GoodsIssue";

import { IGoodsIssue } from "../../../types/Inventory/GoodsIssue";

type Props = {
  referenceUniqueId?: string;
  isLoading?: boolean;
};

const GoodsIssueTab = ({ referenceUniqueId, isLoading }: Props) => {
  const { t } = useTranslation();
  const gridRef = useRef<AgGridReact<IGoodsIssue>>(null);

  if (isLoading) return <LoadingUI />;

  return (
    <>
      <Box mb={2}>
        <Typography variant="h5">{t("inventory.goods_issue.index")}</Typography>
      </Box>
      <GoodsIssueTable
        gridRef={gridRef}
        referenceUniqueId={referenceUniqueId}
      />
    </>
  );
};

export default GoodsIssueTab;
